<template>
  <i-expansion-card icon="functions" label="分组统计">
    <template #default>
      <div class="i-groups-chart__canvas"></div>
      <!-- <q-chip v-for="field of fields" :key="field.name" clickable color="primary" text-color="white" :disabled="field.disabled">
        {{field.label}}
      </q-chip> -->
    </template>
    <template #actions>
      <i-btn round color="action-configure" icon="settings" tooltip-position="top" tooltip-text="设置分组" :glossy="false"/>
      <i-btn round color="action-get" icon="refresh" tooltip-position="top" tooltip-text="刷新" @click="$emit('refresh')" :glossy="false"/>
    </template>
  </i-expansion-card>
</template>
<script>
import * as echarts from 'echarts'

export default {
  props: {
    data: Array,
    fields: Array
  },
  mounted () {
    const chartEl = this.$el.querySelector('.i-groups-chart__canvas')
    const chart = echarts.init(chartEl)
    // 绘制图表
    chart.setOption({
      tooltip: { },
      series: {
        type: 'sunburst',
        data: this.data
      }
    })
  }
}
</script>
<style lang="scss">
.i-groups-chart__canvas {
  width: 100%;
  height: 250px;
}
</style>
